import isElementInViewport from '@/storybook/utils/isElementInViewport';
import { type RefObject, useEffect } from 'react';
import { type Tab } from './TabList';

type UseScrollCurrentTabIntoViewParams<T> = {
  currentTab: Tab<T> | null;
  tabsContainerRef: RefObject<HTMLUListElement | null>;
};

export function useScrollCurrentTabIntoView<T>({
  currentTab,
  tabsContainerRef,
}: UseScrollCurrentTabIntoViewParams<T>): void {
  const currentTabId = currentTab?.id;

  useEffect(() => {
    if (currentTabId === undefined || !tabsContainerRef.current) return;

    const container = tabsContainerRef.current;
    const currentTabElement = container.querySelector(`[id="${String(currentTabId)}"]`);

    if (!currentTabElement) return;

    if (!isElementInViewport(container)) return;

    const containerRect = container.getBoundingClientRect();
    const tabRect = currentTabElement.getBoundingClientRect();

    if (tabRect.left >= containerRect.left && tabRect.right <= containerRect.right) return;

    currentTabElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }, [currentTabId, tabsContainerRef]);
}
